<template>
    <div>
        <el-select 
        :placeholder="$t('Seçin')" 
        filterable v-model="selected"
         @change="handleChange" 
         style="width: 100%">
            <el-option 
            v-for="item in data" 
            :key="item.id" 
            :label="item.name" 
            :value="item.id"></el-option>
        </el-select>
    </div>
</template>

<script>
import { GetPolicyTypes } from "../../services/cls";

export default {
    props: {
        value: [Number, String],
        type:[Number, String]
    },
    data() {
        return {
            data: [],
            selected: this.value,
        };
    },
    methods: {
        handleChange(e) {
            this.$emit("input", e);
            const selectedItem = this.data.find((item) => item.id === e);
            if (selectedItem) {
                this.$emit("policytype", selectedItem.name);
            }
            this.selected = e;
        },

        getData() {
            GetPolicyTypes(this.type).then((response) => {
                if (response.data.data) {
                    this.data = response.data.data;
                } else {
                    this.$message({
                        type: "error",
                        message: "PolicyTypes: No data found!",
                    });
                }
            });
        },
    },
    mounted() {
        this.getData();
    },
    watch: {
        value(newVal) {
            if (newVal !== this.selected) {
                this.selected = newVal;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>